import Mortandad from "./Mortandad";
export default Mortandad;